import { createFileRoute } from "@tanstack/react-router";
import Page from "@/pages/AnamneseRetorno";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/anamnese-retorno")({
  head: () => pageHead({ title: "Anamnese de retorno | Clara Camille", path: "/anamnese-retorno", noindex: true }),
  component: Page,
});
